import { render, staticRenderFns } from "./OrdersByTypeChart.vue?vue&type=template&id=51681489&scoped=true&"
import script from "./OrdersByTypeChart.vue?vue&type=script&lang=js&"
export * from "./OrdersByTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51681489",
  null
  
)

export default component.exports